import { problemsHref, tasksHref } from '../../lib/component-links'
import { AGENT_INSIGHTS_FOLDER_PATH } from './explorer-paths'

const LEGACY_ID_PREFIX = '__axilon_agent_insights_'
const LEGACY_PROBLEMS_ID = `${LEGACY_ID_PREFIX}problems__`
const LEGACY_PROBLEMS_PATH = `${AGENT_INSIGHTS_FOLDER_PATH}/Problems`

/** The removed virtual findings leaves, by their reserved explorer paths. */
const LEGACY_TASK_LEAF_PATHS = new Set(
  [
    'All',
    'Root Cause Analysis',
    'Predictive Maintenance',
    'Bottleneck analysis',
    'Yield & quality',
    'Summary',
    'Spec coverage'
  ].map((leaf) => `${AGENT_INSIGHTS_FOLDER_PATH}/${leaf}`)
)

/**
 * Where an old virtual Agent Insights leaf now lives. Accepts a dashboard
 * path or a legacy `?dashboard=` sentinel id. Problems moved to the
 * top-level Problems page; every other leaf (All, RCA, PM, …) to Tasks.
 * Returns null for anything else — including real agent-linked
 * dashboards under the Agent Insights folder.
 */
export function legacyAgentInsightsHref(pathOrId: string): string | null {
  if (pathOrId === LEGACY_PROBLEMS_ID || pathOrId === LEGACY_PROBLEMS_PATH) {
    return problemsHref()
  }
  if (pathOrId.startsWith(LEGACY_ID_PREFIX) || LEGACY_TASK_LEAF_PATHS.has(pathOrId)) {
    return tasksHref()
  }
  return null
}
